export const initSignalProp = (
    pageOwnerOrganizerId: string,
    cardOrganizerId?: string,
) => {
    const shouldShowOrganizerInfo = pageOwnerOrganizerId !== cardOrganizerId;

    return shouldShowOrganizerInfo ? {} : { signal: undefined };
};
